<template>
    <div class="content-tree sys-center-zuzhijigou">
         <lr-tree :data="treeData" @setTreeWidth="setTreeWidth" :width="width" :loading="treeLoading" :ref="treeBindRef" :bindRef="treeBindRef" nodeKey="ID" :title="treeTitle" @nodeClick="nodeClick" :defaultProps="defaultProps"></lr-tree>
    </div>
</template>

<script>
import {
  getMyDeptTree,
} from "@/api/organization";
export default {
  name: "SelfDeptTree",
  props:{
    width: {
      type: String,
      default: "200px",
    },
  },
  mounted() {
    this.getListFun()
  },
  data() {
    return {
      treeLoading:false,
      treeBindRef:'tree',
        treeTitle:'组织机构',
        defaultProps:{
            'children':'children',
            'label': 'Name'
        },
        treeData:[],
    };
  },
  methods: {
    setTreeWidth(width){
      this.$emit('setTreeWidth', width)
    },
    iconClass(row){
      return row.data.Type===2||row.data.Type===3 ? "icon-biaoqian" : row.data.expanded ? "icon-dakai1" : "icon-wenjiandai" 
    },
    getListFun(){
        const that =this;
        that.treeLoading = true;
        getMyDeptTree().then((res) => {
            if (res.Code === 200) {
                that.treeData = res.Data;
                if(that.treeData.length==0){
                  that.treeLoading = false;
                  return false;
                }
                that.$nextTick(()=>{
                    that.$emit("nodeClick", that.treeData[0]);
                    that.$refs[this.treeBindRef].setCurrentKey(that.treeData[0].ID)
                })
               
            } else {
                this.treeData = [];
            }
            that.treeLoading = false;
        });
    },
    nodeClick(obj){
        this.$emit("nodeClick", obj.obj);
    },
  },
};
</script>
<style scoped  lang="scss">
.content{
    &-tree{
        height: 100%;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/LrOrganization/SelfDeptTree.vue